interface I_Params {
    device: 'PC' | 'M';
    mCloseBtn?: (isOpen: boolean) => void;
}

export const createSearchPanel = ({ device, mCloseBtn }: I_Params) => {
    new window.SearchPanel({
        panel: 'bbc_travelSearch',
        type: `${device === 'PC' ? 'pc_result' : 'm_result'}`,
        target: '_blank',
        rowSkin: true,
        mTitle: '搜尋引擎',
        mCloseBtn: function () {
            mCloseBtn && mCloseBtn(false);
        },
        searchPaneltDidMount: function () {
            // console.log('Search Panel ready!!');
        },
        whenSubmitBtnClick: function () {
            // console.log('when Submit Button on Click!!');
        },
        renderNode: `SearchPanel${device === 'M' ? 'M' : ''}`,
    });
};

export const attractionsCreateSearchPanel = ({ device, mCloseBtn }: I_Params) => {
    new window.SearchPanel({
        panel: 'newTravelSearch',
        type: `${device === 'PC' ? 'pc_result' : 'm_result'}`,
        target: '_blank',
        rowSkin: true,
        mTitle: '搜尋引擎',
        mCloseBtn: function () {
            mCloseBtn && mCloseBtn(false);
        },
        searchPaneltDidMount: function () {
            // console.log('Search Panel ready!!');
        },
        whenSubmitBtnClick: function () {
            // console.log('when Submit Button on Click!!');
        },
        renderNode: `SearchPanel${device === 'M' ? 'M' : ''}`,
    });
};
